var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "max-width": "80%",
        height: "800px",
        bus: _vm.busModal,
        persistent: ""
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              Number(_vm.step) !== 1
                ? [
                    _vm.step < 6
                      ? _c(
                          "BaseButton",
                          {
                            attrs: { underlined: "" },
                            on: { click: _vm.backStep }
                          },
                          [_vm._v(" Voltar ")]
                        )
                      : _vm._e(),
                    (_vm.isWhitelabel && _vm.cancelProcess
                    ? _vm.step < 5
                    : _vm.step < (_vm.has_wirecard_account ? 5 : 6))
                      ? _c(
                          "BaseButton",
                          {
                            attrs: { primary: "" },
                            on: { click: _vm.nextStep }
                          },
                          [_vm._v(" Próximo ")]
                        )
                      : _vm._e(),
                    _vm.isWhitelabel && _vm.cancelProcess && _vm.step === 4
                      ? _c(
                          "BaseButton",
                          { attrs: { primary: "" }, on: { click: close } },
                          [_vm._v(" Sair ")]
                        )
                      : _vm._e(),
                    _vm.step === (_vm.has_wirecard_account ? 5 : 6)
                      ? _c(
                          "BaseButton",
                          {
                            attrs: { primary: "", loading: _vm.loading },
                            on: {
                              click: function($event) {
                                return _vm.salvar(close)
                              }
                            }
                          },
                          [_vm._v(" Salvar ")]
                        )
                      : _vm._e(),
                    _vm.step === (_vm.has_wirecard_account ? 6 : 7) &&
                    _vm.$canSendLinks
                      ? _c(
                          "BaseButton",
                          {
                            attrs: { primary: "" },
                            on: {
                              click: function($event) {
                                return _vm.openSendLink(close)
                              }
                            }
                          },
                          [_vm._v(" Enviar link ")]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: "Cadastre um serviço",
          subtitle: "Receba dos seus clientes de forma automática"
        }
      }),
      _c(
        "div",
        { staticClass: "v-application" },
        [
          _vm.loadingCheck
            ? _c("v-row", { attrs: { justify: "center", align: "center" } }, [
                _c(
                  "div",
                  { staticClass: "text-center ma-12 w-100" },
                  [
                    _c("v-progress-circular", {
                      attrs: { size: 50, color: "primary", indeterminate: "" }
                    })
                  ],
                  1
                )
              ])
            : _c(
                "v-stepper",
                {
                  staticClass: "elevation-0",
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.step,
                    callback: function($$v) {
                      _vm.step = $$v
                    },
                    expression: "step"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    { staticClass: "elevation-0" },
                    [
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            editable: _vm.step > 1 && !_vm.concluido,
                            complete: _vm.step > 1,
                            step: "1"
                          }
                        },
                        [_vm._v(" Modelo ")]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            editable: _vm.step > 2 && !_vm.concluido,
                            complete: _vm.step > 2,
                            step: "2"
                          }
                        },
                        [_vm._v(" Dados básicos ")]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            editable:
                              _vm.step > 3 && !_vm.concluido && !_vm.its_free,
                            complete: _vm.step > 3,
                            step: "3"
                          }
                        },
                        [_vm._v(" Cobrança ")]
                      ),
                      _c("v-divider"),
                      !_vm.has_wirecard_account
                        ? _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                editable: _vm.step > 4 && !_vm.concluido,
                                complete: _vm.step > 4,
                                step: "4"
                              }
                            },
                            [_vm._v(" Recebimento ")]
                          )
                        : _vm._e(),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            editable:
                              _vm.step > (_vm.has_wirecard_account ? 4 : 5) &&
                              !_vm.concluido,
                            complete:
                              _vm.step > (_vm.has_wirecard_account ? 4 : 5),
                            step: _vm.has_wirecard_account ? 4 : 5
                          }
                        },
                        [_vm._v(" Indicação ")]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            step: _vm.has_wirecard_account ? 5 : 6,
                            editable:
                              _vm.step > (_vm.has_wirecard_account ? 5 : 6) &&
                              !_vm.concluido,
                            complete:
                              _vm.step > (_vm.has_wirecard_account ? 5 : 6)
                          }
                        },
                        [_vm._v(" Configurar ")]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            editable:
                              _vm.step > (_vm.has_wirecard_account ? 6 : 7) &&
                              !_vm.concluido,
                            complete:
                              _vm.step > (_vm.has_wirecard_account ? 6 : 7),
                            step: _vm.has_wirecard_account ? 6 : 7
                          }
                        },
                        [_vm._v(" Confirmação ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-items",
                    { staticClass: "elevation-0" },
                    [
                      _c(
                        "v-stepper-content",
                        { staticClass: "pt-0 pb-0", attrs: { step: "1" } },
                        [
                          _vm.step === 1
                            ? _c("v-simple-table", {
                                key: "tabela-modelos-servicos",
                                ref: "table-servicos",
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function() {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Nome")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Descricao")]
                                              ),
                                              _c("th")
                                            ])
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(_vm.modelos, function(item) {
                                              return _c(
                                                "tr",
                                                {
                                                  key: item.title,
                                                  style: { cursor: "pointer" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.doActions(
                                                        item.actions
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("td", [
                                                    _vm._v(_vm._s(item.title))
                                                  ]),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.subtitle)
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            icon: "",
                                                            small: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "mdi-chevron-right"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1279782640
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "formDadosBasicos",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                }
                              },
                              model: {
                                value: _vm.validDadosBasicos,
                                callback: function($$v) {
                                  _vm.validDadosBasicos = $$v
                                },
                                expression: "validDadosBasicos"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "col-12",
                                    attrs: {
                                      label: "Nome*",
                                      rules: [_vm.rules.required],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.servico.nome,
                                      callback: function($$v) {
                                        _vm.$set(_vm.servico, "nome", $$v)
                                      },
                                      expression: "servico.nome"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-textarea", {
                                attrs: { label: "Descrição" },
                                model: {
                                  value: _vm.servico.descricao,
                                  callback: function($$v) {
                                    _vm.$set(_vm.servico, "descricao", $$v)
                                  },
                                  expression: "servico.descricao"
                                }
                              }),
                              _c("v-checkbox", {
                                attrs: {
                                  required: "",
                                  rules: [_vm.rules.required]
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(" Eu aceito os "),
                                            _c("v-tooltip", {
                                              attrs: {
                                                bottom: "",
                                                disabled: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "a",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href:
                                                                "https://aawz-public.s3.us-east-2.amazonaws.com/politicas/Termos%20de%20Uso.pdf"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              }
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " Termos de Uso.* "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ])
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.aceptTerms,
                                  callback: function($$v) {
                                    _vm.aceptTerms = $$v
                                  },
                                  expression: "aceptTerms"
                                }
                              })
                            ],
                            1
                          ),
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v("* Campo obrigatório")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "3" } },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "formTaxa",
                              model: {
                                value: _vm.validTaxa,
                                callback: function($$v) {
                                  _vm.validTaxa = $$v
                                },
                                expression: "validTaxa"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-space-between pl-2" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "v-application",
                                      staticStyle: { "align-items": "center" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Valor fixo",
                                          disabled: _vm.its_free
                                        },
                                        model: {
                                          value: _vm.taxaBruta,
                                          callback: function($$v) {
                                            _vm.taxaBruta = $$v
                                          },
                                          expression: "taxaBruta"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-secondary d-inline pl-3"
                                        },
                                        [
                                          _vm._v(
                                            " Valor cobrado invariavelmente. "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      { attrs: { small: "" } },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "mdi-alert-circle-outline"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " Nos serviços recorrentes, as cobranças iniciam no mês seguinte a contratação. "
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.taxaBruta
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "money",
                                                        rawName: "v-money",
                                                        value: _vm.maskMoney,
                                                        expression: "maskMoney"
                                                      }
                                                    ],
                                                    attrs: {
                                                      rules: [
                                                        _vm.rules.taxMinReal
                                                      ],
                                                      label: "Valor*"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.servico.taxaBruta,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.servico,
                                                          "taxaBruta",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "servico.taxaBruta"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                [
                                                  _c("v-select", {
                                                    staticStyle: {
                                                      "margin-top": "10px"
                                                    },
                                                    attrs: {
                                                      items: [
                                                        "À vista",
                                                        "Parcelado",
                                                        "Recorrente"
                                                      ],
                                                      label:
                                                        "Forma de pagamento",
                                                      rules: [
                                                        _vm.rules.metodoBruto
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.servico.metodoBruto,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.servico,
                                                          "metodoBruto",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "servico.metodoBruto"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm.servico.metodoBruto ===
                                              "Parcelado"
                                                ? _c(
                                                    "v-col",
                                                    [
                                                      _c("v-select", {
                                                        attrs: {
                                                          items:
                                                            _vm.opcoesParcelas,
                                                          label: "Parcelas"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.servico
                                                              .qtdParcelas,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.servico,
                                                              "qtdParcelas",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "servico.qtdParcelas"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "justify-space-between pl-2" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "v-application",
                                      staticStyle: { "align-items": "center" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "d-inline",
                                        staticStyle: { width: "fit-content" },
                                        attrs: {
                                          disabled: _vm.its_free,
                                          label: "Taxa sobre o patrimônio"
                                        },
                                        on: { change: _vm.statusNextButton },
                                        model: {
                                          value: _vm.taxaPatrimonio,
                                          callback: function($$v) {
                                            _vm.taxaPatrimonio = $$v
                                          },
                                          expression: "taxaPatrimonio"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-secondary d-inline pl-3"
                                        },
                                        [
                                          _vm._v(
                                            " Taxa anual cobrada mensalmente (semelhante à taxa de administração de fundos). "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.taxaPatrimonio
                                    ? _c(
                                        "v-row",
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "money",
                                                rawName: "v-money",
                                                value: _vm.maskPercent,
                                                expression: "maskPercent"
                                              }
                                            ],
                                            staticClass: "col-2",
                                            attrs: {
                                              rules: [_vm.rules.taxMinPerc],
                                              label: "Taxa*"
                                            },
                                            model: {
                                              value: _vm.servico.taxaPatrimonio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.servico,
                                                  "taxaPatrimonio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "servico.taxaPatrimonio"
                                            }
                                          }),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "money",
                                                rawName: "v-money",
                                                value: _vm.maskMoney,
                                                expression: "maskMoney"
                                              }
                                            ],
                                            staticClass: "col-2",
                                            attrs: {
                                              label: "Valor mínimo*",
                                              rules: [_vm.rules.taxMinReal]
                                            },
                                            model: {
                                              value: _vm.servico.valorMinimo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.servico,
                                                  "valorMinimo",
                                                  $$v
                                                )
                                              },
                                              expression: "servico.valorMinimo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "small",
                                { staticClass: "text-secondary mt-3" },
                                [_vm._v("* Campos obrigatórios")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      !_vm.has_wirecard_account
                        ? _c("v-stepper-content", { attrs: { step: "4" } }, [
                            _vm.cadastrarConta
                              ? _c(
                                  "div",
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "pl-2 mt-0 pt-2",
                                      attrs: {
                                        label: "Pessoa jurídica",
                                        dense: ""
                                      },
                                      model: {
                                        value: _vm.pj,
                                        callback: function($$v) {
                                          _vm.pj = $$v
                                        },
                                        expression: "pj"
                                      }
                                    }),
                                    _c(
                                      "h1",
                                      { staticClass: "subhead" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.pj
                                                ? "Dados do representante"
                                                : "Dados pessoais"
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              small: "",
                                              loading: _vm.loadingDadosPessoais
                                            },
                                            on: {
                                              click: _vm.carregarDadosPessoais
                                            }
                                          },
                                          [_vm._v(" Carregar dados pessoais ")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "CardDiv",
                                      [
                                        _c(
                                          "v-form",
                                          {
                                            ref: "formDadosPessoais",
                                            attrs: { "lazy-validation": true },
                                            model: {
                                              value: _vm.validDadosPessoais,
                                              callback: function($$v) {
                                                _vm.validDadosPessoais = $$v
                                              },
                                              expression: "validDadosPessoais"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "col-6",
                                                  attrs: {
                                                    label: "Primeiro nome*",
                                                    rules: [_vm.rules.required],
                                                    required: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais
                                                        .firstname,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "firstname",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.firstname"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-6",
                                                  attrs: {
                                                    rules: [_vm.rules.required],
                                                    required: "",
                                                    label: "Último nome*"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais
                                                        .lastname,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "lastname",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.lastname"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-6",
                                                  attrs: {
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.email
                                                    ],
                                                    required: "",
                                                    label: "E-mail*"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "email",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.email"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: _vm.maskPhone,
                                                      expression: "maskPhone"
                                                    }
                                                  ],
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.phone
                                                    ],
                                                    required: "",
                                                    label: "Telefone*"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais
                                                        .telefone,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "telefone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.telefone"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: _vm.maskCPF,
                                                      expression: "maskCPF"
                                                    }
                                                  ],
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.cpf
                                                    ],
                                                    required: "",
                                                    label: "CPF*"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.cpf,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "cpf",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.cpf"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: _vm.maskData,
                                                      expression: "maskData"
                                                    }
                                                  ],
                                                  staticClass: "col-4",
                                                  attrs: {
                                                    label:
                                                      "Data de nascimento*",
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.data
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais
                                                        .data_nascimento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "data_nascimento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.data_nascimento"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c("v-divider"),
                                            _c(
                                              "v-row",
                                              [
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: _vm.maskCEP,
                                                      expression: "maskCEP"
                                                    }
                                                  ],
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "CEP*",
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.cep
                                                    ],
                                                    required: ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.getCepDadosPessoais
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.cep,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "cep",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.cep"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-6",
                                                  attrs: {
                                                    label: "Rua",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.rua,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "rua",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.rua"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: _vm.maskNumber,
                                                      expression: "maskNumber"
                                                    }
                                                  ],
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Número*",
                                                    rules: [_vm.rules.required],
                                                    required: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.numero,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "numero",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.numero"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Complemento"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais
                                                        .complemento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "complemento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.complemento"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Bairro",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.bairro,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "bairro",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.bairro"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Cidade",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.cidade,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "cidade",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.cidade"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Estado",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_pessoais.estado,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_pessoais,
                                                        "estado",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_pessoais.estado"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.pj
                                      ? _c(
                                          "h1",
                                          { staticClass: "subhead mt-10" },
                                          [_vm._v("Dados da empresa")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-form",
                                      {
                                        ref: "formDadosEmpresariais",
                                        attrs: { "lazy-validation": "" },
                                        model: {
                                          value: _vm.validDadosEmpresariais,
                                          callback: function($$v) {
                                            _vm.validDadosEmpresariais = $$v
                                          },
                                          expression: "validDadosEmpresariais"
                                        }
                                      },
                                      [
                                        _vm.pj
                                          ? _c(
                                              "CardDiv",
                                              [
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass: "col-6",
                                                        attrs: {
                                                          label:
                                                            "Nome fantasia*",
                                                          rules: [
                                                            _vm.rules.required
                                                          ],
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .nome_fantasia,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "nome_fantasia",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.nome_fantasia"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-6",
                                                        attrs: {
                                                          label:
                                                            "Razão social*",
                                                          rules: [
                                                            _vm.rules.required
                                                          ],
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .razao_social,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "razao_social",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.razao_social"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              _vm.maskPhone,
                                                            expression:
                                                              "maskPhone"
                                                          }
                                                        ],
                                                        staticClass: "col-6",
                                                        attrs: {
                                                          rules: [
                                                            _vm.rules.required,
                                                            _vm.rules.phone
                                                          ],
                                                          required: "",
                                                          label: "Telefone*"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .telefone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "telefone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.telefone"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: _vm.maskCNPJ,
                                                            expression:
                                                              "maskCNPJ"
                                                          }
                                                        ],
                                                        staticClass: "col-6",
                                                        attrs: {
                                                          rules: [
                                                            _vm.rules.required,
                                                            _vm.rules.cnpj
                                                          ],
                                                          required: "",
                                                          label: "CNPJ*"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .cnpj,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "cnpj",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.cnpj"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-divider"),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: _vm.maskCEP,
                                                            expression:
                                                              "maskCEP"
                                                          }
                                                        ],
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          rules: [
                                                            _vm.rules.required,
                                                            _vm.rules.cep
                                                          ],
                                                          required: "",
                                                          label: "CEP*"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.getCepDadosEmpresariais
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .cep,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "cep",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.cep"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-6",
                                                        attrs: {
                                                          label: "Rua",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .rua,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "rua",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.rua"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              _vm.maskNumber,
                                                            expression:
                                                              "maskNumber"
                                                          }
                                                        ],
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          label: "Número*",
                                                          rules: [
                                                            _vm.rules.required
                                                          ],
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .numero,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "numero",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.numero"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          label: "Complemento"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .complemento,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "complemento",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.complemento"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          label: "Bairro",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .bairro,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "bairro",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.bairro"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          label: "Cidade",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .cidade,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "cidade",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.cidade"
                                                        }
                                                      }),
                                                      _c("v-text-field", {
                                                        staticClass: "col-3",
                                                        attrs: {
                                                          label: "Estado",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .dados_empresariais
                                                              .estado,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dados_empresariais,
                                                              "estado",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dados_empresariais.estado"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c("h1", { staticClass: "subhead mt-10" }, [
                                      _vm._v("Dados bancários")
                                    ]),
                                    _c(
                                      "CardDiv",
                                      [
                                        _c(
                                          "v-form",
                                          {
                                            ref: "formDadosBancarios",
                                            attrs: { "lazy-validation": "" },
                                            model: {
                                              value: _vm.validDadosBancarios,
                                              callback: function($$v) {
                                                _vm.validDadosBancarios = $$v
                                              },
                                              expression: "validDadosBancarios"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "col-7",
                                                  attrs: {
                                                    label: "Nome do titular*",
                                                    rules: [_vm.rules.required]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_bancarios.nome,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_bancarios,
                                                        "nome",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_bancarios.nome"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: [
                                                        _vm.maskCPF,
                                                        _vm.maskCNPJ
                                                      ],
                                                      expression:
                                                        "[maskCPF, maskCNPJ]"
                                                    }
                                                  ],
                                                  staticClass: "col-5",
                                                  attrs: {
                                                    label:
                                                      "Documento do titular (CPF ou CNPJ)*",
                                                    rules: [
                                                      _vm.rules.required,
                                                      _vm.rules.cpf_cnpj
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_bancarios
                                                        .documento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_bancarios,
                                                        "documento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_bancarios.documento"
                                                  }
                                                }),
                                                _c("v-autocomplete", {
                                                  staticClass: "col-7",
                                                  attrs: {
                                                    label: "Banco*",
                                                    items: _vm.bancos,
                                                    "item-text": function(
                                                      item
                                                    ) {
                                                      return (
                                                        item.codigo +
                                                        " - " +
                                                        item.nome
                                                      )
                                                    },
                                                    "item-value": "codigo",
                                                    clearable: "",
                                                    filter:
                                                      _vm.filterAutocomplete,
                                                    rules: [_vm.rules.required]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_bancarios
                                                        .codigo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_bancarios,
                                                        "codigo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_bancarios.codigo"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: [
                                                        "####",
                                                        "####-#",
                                                        "####-##"
                                                      ],
                                                      expression:
                                                        "['####', '####-#', '####-##']"
                                                    }
                                                  ],
                                                  staticClass: "col-2",
                                                  attrs: {
                                                    label: "Agência*",
                                                    rules: [_vm.rules.required]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_bancarios
                                                        .agencia,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_bancarios,
                                                        "agencia",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_bancarios.agencia"
                                                  }
                                                }),
                                                _c("v-text-field", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: [
                                                        "###-#",
                                                        "####-#",
                                                        "#####-#",
                                                        "######-#",
                                                        "#######-#",
                                                        "########-#",
                                                        "#########-#"
                                                      ],
                                                      expression:
                                                        "[\n                      '###-#',\n                      '####-#',\n                      '#####-#',\n                      '######-#',\n                      '#######-#',\n                      '########-#',\n                      '#########-#',\n                    ]"
                                                    }
                                                  ],
                                                  staticClass: "col-3",
                                                  attrs: {
                                                    label: "Conta*",
                                                    rules: [_vm.rules.required]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dados_bancarios.conta,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dados_bancarios,
                                                        "conta",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dados_bancarios.conta"
                                                  }
                                                }),
                                                _vm.dados_bancarios.codigo ===
                                                -1
                                                  ? _c("v-text-field", {
                                                      staticClass: "col-7",
                                                      attrs: {
                                                        label: "Nome do banco*",
                                                        rules: [
                                                          _vm.rules.required
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.outro_nome,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.outro_nome = $$v
                                                        },
                                                        expression: "outro_nome"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm.dados_bancarios.codigo ===
                                                -1
                                                  ? _c("v-text-field", {
                                                      staticClass: "col-5",
                                                      attrs: {
                                                        label:
                                                          "Código do banco*",
                                                        rules: [
                                                          _vm.rules.required
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.outro_codigo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.outro_codigo = _vm._n(
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "outro_codigo"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "text-secondary mt-5" },
                                      [_vm._v("* Campos obrigatórios")]
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row justify-center font-weight-bold",
                                    staticStyle: { padding: "15px" }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(this.messageReceivingAccount)
                                      )
                                    ])
                                  ]
                                )
                          ])
                        : _vm._e(),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: _vm.has_wirecard_account ? 4 : 5 } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "v-application",
                              staticStyle: { "align-items": "center" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Indicar serviço" },
                                model: {
                                  value: _vm.indicar_servico,
                                  callback: function($$v) {
                                    _vm.indicar_servico = $$v
                                  },
                                  expression: "indicar_servico"
                                }
                              }),
                              _c(
                                "small",
                                { staticClass: "text-secondary d-inline pl-3" },
                                [
                                  _vm._v(
                                    " Seu serviço ficará disponível para indicação. "
                                  )
                                ]
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              { attrs: { small: "" } },
                                              on
                                            ),
                                            [_vm._v("mdi-alert-circle-outline")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "text-align": "justify" }
                                    },
                                    [
                                      _vm._v(
                                        " Você deseja remunerar quem indicar esse serviço para você? "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " Insira uma porcentagem e deixe disponibilizado o serviço. "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " Seus profissionais autorizados irão enviar o link desse serviço para clientes e, assim que esses "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " clientes contratarem pelo link enviado nós cuidamos dos repasses de acordo com a % que você inserir. "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm.indicar_servico
                            ? _c(
                                "div",
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "money",
                                        rawName: "v-money",
                                        value: _vm.maskPercent,
                                        expression: "maskPercent"
                                      }
                                    ],
                                    attrs: {
                                      rules: [_vm.rules.taxMinPerc],
                                      label: "Porcentagem de repasse*"
                                    },
                                    model: {
                                      value: _vm.pct_repasse,
                                      callback: function($$v) {
                                        _vm.pct_repasse = $$v
                                      },
                                      expression: "pct_repasse"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          staticStyle: { height: "330px" },
                          attrs: { step: _vm.has_wirecard_account ? 5 : 6 }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "CardDiv",
                                    { attrs: { secondary: "" } },
                                    [
                                      !_vm.urlImagem
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-center align-items-center text-center d-flex",
                                              staticStyle: { height: "90%" }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "text-secondary"
                                                },
                                                [
                                                  _vm._v(
                                                    " Nenhuma imagem selecionada "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("v-img", {
                                        staticClass: "p-0 border",
                                        attrs: {
                                          src: _vm.urlImagem,
                                          "aspect-ratio": "1",
                                          contain: "",
                                          height: "250"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "justify-content-center align-items-center",
                                  attrs: { cols: "6" }
                                },
                                [
                                  _c(
                                    "v-form",
                                    { ref: "formConfig" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex flex-inline",
                                          staticStyle: {
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticStyle: { padding: "0px" },
                                              attrs: { cols: "12", md: "11" }
                                            },
                                            [
                                              _c("v-file-input", {
                                                ref: "servicoImagem",
                                                attrs: {
                                                  "prepend-icon": "image",
                                                  accept: "image/*",
                                                  label:
                                                    "Imagem de corpo de e-mail",
                                                  "show-size": "",
                                                  rules: [_vm.rules.maxSize]
                                                },
                                                on: {
                                                  change: _vm.changeUploadImage
                                                },
                                                model: {
                                                  value: _vm.fileImagem,
                                                  callback: function($$v) {
                                                    _vm.fileImagem = $$v
                                                  },
                                                  expression: "fileImagem"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticStyle: {
                                                "margin-left": "2px"
                                              },
                                              attrs: { cols: "12", md: "1" }
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g({}, on),
                                                            [
                                                              _vm._v(
                                                                "mdi-alert-circle-outline"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ])
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " Utilize essa imagem para enviar alguma informação ou arte atrelada ao seu serviço. " +
                                                        _vm._s(
                                                          this.isWhitelabel
                                                            ? "Sua logo e cores é enviada dentro do modelo de e-mail."
                                                            : ""
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-file-input", {
                                        attrs: {
                                          label: "Arquivo de anexo",
                                          "show-size": "",
                                          rules: [_vm.rules.maxSize]
                                        },
                                        model: {
                                          value: _vm.fileAnexo,
                                          callback: function($$v) {
                                            _vm.fileAnexo = $$v
                                          },
                                          expression: "fileAnexo"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex flex-inline",
                                          staticStyle: {
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticStyle: { padding: "0px" },
                                              attrs: { cols: "12", md: "11" }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "hide-details": "",
                                                  dense: "",
                                                  label:
                                                    "Tornar serviço visível para qualquer cliente"
                                                },
                                                model: {
                                                  value: _vm.servico.visivel,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.servico,
                                                      "visivel",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "servico.visivel"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticStyle: {
                                                "margin-left": "2px",
                                                "padding-bottom": "0px"
                                              },
                                              attrs: { cols: "12", md: "1" }
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g({}, on),
                                                            [
                                                              _vm._v(
                                                                "mdi-alert-circle-outline"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ])
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          this.isWhitelabel
                                                            ? "Ao marcar essa opção, qualquer cliente que acessar seu aplicativo poderá ver esse serviço e realizar contratação a qualquer momento."
                                                            : ""
                                                        ) +
                                                        " Deixe desmarcado se deseja que as contratações sejam realizadas apenas quando você enviar um link/e-mail para seus clientes. "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticStyle: { padding: "0px" },
                                          attrs: { cols: "12", md: "12" }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                              label:
                                                "Tornar serviço visível para qualquer profissional"
                                            },
                                            model: {
                                              value:
                                                _vm.servico
                                                  .visivel_para_profissionais,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.servico,
                                                  "visivel_para_profissionais",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "servico.visivel_para_profissionais"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: _vm.has_wirecard_account ? 6 : 7 } },
                        [
                          _c("p", [
                            _vm._v(
                              " Parabéns! Serviço cadastrado com sucesso! "
                            )
                          ]),
                          !_vm.its_free && !_vm.has_wirecard_account
                            ? _c("p", [
                                _vm._v(
                                  " Você receberá um e-mail da AAWZ e de nossa parceira de pagamentos explicando como gerenciar seus recebimentos. "
                                )
                              ])
                            : _vm._e(),
                          _c("p", [
                            _vm._v(" Para ver seu serviço cadastrado, clique "),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: { click: _vm.toServices }
                              },
                              [_vm._v("aqui")]
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              " Para enviar um link de adesão dos serviços para seus clientes, clique "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: { click: _vm.toServices }
                              },
                              [_vm._v("aqui")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }